import React from "react";
import Input from "./Input";
import DeleteRowButton from "./DeleteRowButton";
import { Image } from "lib/components/vendor";
import { generateUuid } from "lib/utils/socialtravel";

export default class ImageAttachmentControl extends React.PureComponent {
  state = {
    uploadedFile: null,
    uploadedFileData: null,
  };

  handleInputChange(_, event) {
    const { value: attachment, onChange } = this.props;
    const file = event.target.files[0];
    const nextAttachment = attachment
      ? { ...attachment, file, _destroy: !file }
      : { id: null, uuid: generateUuid(), file, _destroy: !file };
    onChange(nextAttachment);

    this.setState({ uploadedFile: file, uploadedFileData: null });
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (this.state.uploadedFile === file) {
          this.setState({ uploadedFileData: event.target.result });
        }
      };
      reader.readAsDataURL(file);
    }
  }

  handleRemoveClick() {
    const { value: attachment, onChange } = this.props;
    const nextAttachment = attachment.id ? { ...attachment, file: null, _destroy: true } : null;
    onChange(nextAttachment);
  }

  render() {
    const { value: attachment } = this.props;
    const { uploadedFile, uploadedFileData } = this.state;
    const hasFile = attachment && attachment.file;
    const hasOriginalFile = hasFile && attachment.file && attachment.file.url;
    const hasUploadedFile = hasFile && !!uploadedFile && attachment.file === uploadedFile;
    const imageUrl = hasOriginalFile ? attachment.file.url : hasUploadedFile ? uploadedFileData : null;

    return (
      <div className="field">
        <div className="u-displayInlineBlock u-positionRelative">
          <Input type="file" onChange={this.handleInputChange.bind(this)} className="u-massiveWidth" />

          {hasFile && <DeleteRowButton onClick={this.handleRemoveClick.bind(this)} />}
        </div>

        {imageUrl && <Image src={imageUrl} size="medium" className="u-marginTop" />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/ImageAttachment.jsx